import FormJaivana from 'dashboard_jaivana_v1';



class CustomFormulasProductos extends FormJaivana.form {
    constructor(props) {
        super(props);
        this.initForm = this.initForm.bind(this);
        this.setButtonBajar = this.setButtonBajar.bind(this);
        this.setButtonSubir = this.setButtonSubir.bind(this);
        this.grabarDatos = this.grabarDatos.bind(this);
        this.successPostSustituto = this.successPostSustituto.bind(this);
        this.deleteEspecification = this.deleteEspecification.bind(this);
        this.successDelete = this.successDelete.bind(this);
        this.consultarEspecificaciones = this.consultarEspecificaciones.bind(this);
        this.setButtonDelete = this.setButtonDelete.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.openModal = this.openModal.bind(this);
        this.verificacionFabricado = this.verificacionFabricado.bind(this);
        this.cambiarOrden = this.cambiarOrden.bind(this);
        this.successChangeOrden = this.successChangeOrden.bind(this);
        this.successNuevoOrden = this.successNuevoOrden.bind(this);
        this.successSustituto = this.successSustituto.bind(this);
        this.confirmDeleteCustom = this.confirmDeleteCustom.bind(this);
        this.id_delete = 0;
        this.produccionformulaciones_id = 0;
        this.tam = 0;
        this.arrEtap = [];
        this.limpiarCamposModal = this.limpiarCamposModal.bind(this);
        this.initElementModal = this.initElementModal.bind(this);
        this.setButtonProcedimiento = this.setButtonProcedimiento.bind(this);
        this.openModalProcedimiento = this.openModalProcedimiento.bind(this);
        this.recuperarProcedimiento = this.recuperarProcedimiento.bind(this);
        this.guardarProcedimiento = this.guardarProcedimiento.bind(this);
        this.successGuardarProcedimiento = this.successGuardarProcedimiento.bind(this);
    }

    initForm() {
        console.log('Formulas productos componentes @version: 1.01.0034, @author: Cristian Ciro');

        this.getField('btnConsultar').setClick(this.consultarEspecificaciones);
        this.getField('btnNuevo').setClick(this.openModal);
        this.getField('codigo').setOnChange(this.limpiar);
        this.getField('btnGuardar').setClick(this.guardarProcedimiento);
        this.getField('btnCancelar').setClick(() => this.getField('modalProcedimiento').handleClose());
    }

    verificacionFabricado(data) {
        if (data !== undefined) {
            if (this.getField('codigo').getValue() !== data.codigo) {
                this.getField('codigo_articulo_modal').setError(false, '');
                if (data.es_producto_fabricado_id === 1) {
                    this.getField('codigo_articulo_modal').setError(true, '* El artículo debe ser creado por la empresa');
                    this.getField('nombre_articulo_mod').setValue('');
                    this.getField('articulo_componente_id').setValue('');
                }
                else
                    this.getField('codigo_articulo_modal').setError(false, '');
            } else {
                this.getField('codigo_articulo_modal').setError(true, '* El artículo componente no puede ser el mismo');
                this.getField('nombre_articulo_mod').setValue('');
                this.getField('articulo_componente_id').setValue('');
            }
        }
    }

    openModal() {
        this.getField('modalFormulas').handleClickOpen(this.initElementModal());
        this.limpiarCamposModal();
    }

    initElementModal() {
        if (this.getField('codigo').valid() & this.getField('nombre').valid() & this.getField('articulo_id').valid()) {
            let datos = {
                datos:{
                    value: this.getField('articulo_id').getValue()+"",    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'orden', operacion_tipo: 'consulta' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method: 'GET',
                body: datos,
                success: this.successNuevoOrden,
                error: this.error_,
                general: this.generalFormatPmv
            });
            /*this.generalFormat.nombre_accion = 'servicio_traer_orden_formulas_prod'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: body,
                    success: this.successNuevoOrden,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        } else {
            this.getField('modalFormulas').handleClose();
            this.limpiarCamposModal();
        }
    }

    successNuevoOrden(data) {
        if (data.estado_p === 200) {
            this.getField('orden_mod').setValue(data.model[0].orden);
            this.getField('btnGrabar').setClick(this.grabarDatos);
            this.getField('codigo_articulo_modal').setCustomSuccess(this.verificacionFabricado);
            if (data.data[0].orden === null) {
                this.getField('orden_mod').setValue(1);
            }
        }
    }

    consultarEspecificaciones() {
        let articulo_id = this.getField('articulo_id').getValue();
        if (articulo_id !== '' && articulo_id !== 0 && articulo_id !== undefined) {
            this.getField('codigo').setError(false, '');
            if (this.getField('codigo').valid() & this.getField('nombre').valid() & this.getField('articulo_id').valid()) {
                let datos = {
                    datos:{
                        value: this.getField('articulo_id').getValue()+"",    //value: 150432//150442
                        produccionformulasversiones_id: this.getField('produccionformulasversiones_id').getValue(),
                    }
                }

                this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'articuloid', operacion_tipo: 'consulta' };
                this.service.send({
                    endpoint: this.constant.formConfiguration(),
                    method: 'GET',
                    body: datos,
                    success: this.successSustituto,
                    error: this.error_,
                    general: this.generalFormatPmv
                });
                /*this.generalFormat.nombre_accion = 'servicio_traer_produccion_formulas_productos_articulo_id'; // nombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
                this.service.send(
                    {
                        endpoint: this.constant.formConfiguration(),
                        method: 'GET',
                        body: body,
                        success: this.successSustituto,
                        error: this.error_,
                        general: this.generalFormat
                    });*/
            }
        }
    }

    limpiar() {
        this.getField('btnNuevo').setVisible(false);
        this.getField('tablaFormulaProductos').toggle(false);
    }

    successSustituto(data) {
        this.getField('btnNuevo').setVisible(true);
        if (data.model !== undefined) {
            if (data.model.length > 0) {
                this.arrEtap = data.model;
                this.tam = data.model.length;

                this.arrEtap.map(item => {
                    item.habilitadoSubir = false;
                    item.habilitadoBajar = false;

                    return null;
                });

                if (this.arrEtap.length === 2) {
                    //console.log('entro =2');
                    if (this.arrEtap[0].etapa_id === this.arrEtap[1].etapa_id) {
                        this.arrEtap[0].habilitadoBajar = true;
                        this.arrEtap[1].habilitadoSubir = true;
                    }

                } else if (this.arrEtap.length >= 3) {
                    //console.log('entro >=3')
                    for (let i = 1; i < this.arrEtap.length - 1; i++) {

                        if (this.arrEtap[i - 1].etapa_id === this.arrEtap[i].etapa_id) {
                            this.arrEtap[i - 1].habilitadoBajar = true;
                            this.arrEtap[i].habilitadoSubir = true;
                        }

                        if (this.arrEtap[i].etapa_id === this.arrEtap[i + 1].etapa_id) {
                            this.arrEtap[i + 1].habilitadoSubir = true;
                            this.arrEtap[i].habilitadoBajar = true;
                        }
                    }
                }

                //console.log('habilitado o no: ',this.arrEtap);

                let configCell = new Map();
                configCell.set(0, { cellRenderer: this.setButtonDelete, field: 'Operación 1' });
                configCell.set(1, { cellRenderer: this.setButtonSubir, field: 'Operación 2' });
                configCell.set(2, { cellRenderer: this.setButtonBajar, field: 'Operación 3' });
                configCell.set(3, { cellRenderer: this.setButtonProcedimiento, field: 'Operación 4' });
                this.gridOptions['rowData'] = this.arrEtap;
                this.tamanoDatos = this.arrEtap;
                this.getField('tablaFormulaProductos').initData(this.gridOptions, configCell);
                //this.gridOptions.api.sizeColumnsToFit();
                const allColumnIds = [];
                this.gridOptions.columnApi.getAllColumns().forEach((column) => {
                    allColumnIds.push(column.getId());
                });

                this.gridOptions.columnApi.autoSizeColumns(allColumnIds, true);

            } else {
                this.getField('tablaFormulaProductos').toggle(false);
            }
        }
    }

    setButtonDelete(props) {
        let id = props.data.id;

        let button = document.createElement("input");
        button.onclick = () => this.deleteEspecification(id);
        button.setAttribute("id", 'button_delete_' + id);
        button.setAttribute("type", "button");
        button.setAttribute("class", "buttonStyle");
        button.setAttribute("value", "Eliminar");
        return this.createElementJaivana(button);
    }

    setButtonSubir(props) {
        let id = props.data.id;
        let position = parseInt(props.node.id);

        let button = document.createElement("input");
        button.onclick = () => this.cambiarOrden(position, 1);
        button.setAttribute("id", 'button_subir_' + id);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Subir");

        if (props.data.habilitadoSubir === false) {
            button.setAttribute("class", "buttonDisabled");
            button.setAttribute("disabled", true);
        }

        return this.createElementJaivana(button);
    }

    setButtonBajar(props) {
        let id = props.data.id;
        let position = parseInt(props.node.id);
        let button = document.createElement("input");
        button.onclick = () => this.cambiarOrden(position, 0);
        button.setAttribute("id", 'button_bajar_' + id);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Bajar");

        if (props.data.habilitadoBajar === false) {
            button.setAttribute("class", "buttonDisabled");
            button.setAttribute("disabled", true);
        }

        return this.createElementJaivana(button);
    }

    setButtonProcedimiento(props) {
        let id = props.data.id;
        let data = props.data;
        let button = document.createElement("input");

        button.onclick = () => {
            this.openModalProcedimiento(data)
            this.getField('procedimiento').setError(false, '')
        };
        button.setAttribute("id", 'procedimiento' + id);
        button.setAttribute("class","buttonStyle");
        button.setAttribute("type", "button");
        button.setAttribute("value", "Procedimiento");

        return this.createElementJaivana(button);
    }

    openModalProcedimiento(data) {
        this.getField('codigo_comp').setValue(data.codigo_componente);
        this.getField('nombre_comp').setValue(data.nombre_componente);
        this.getField('modalProcedimiento').handleClickOpen(this.recuperarProcedimiento(data));
    }

    recuperarProcedimiento(data) {
        this.getField('procedimiento').setValue(data.procedimiento);
        this.getField('etapa_id_select').setValue(data.etapa_id);
    }

    guardarProcedimiento() {
        if (this.getField('procedimiento').getValue() !== '' && this.getField('procedimiento').getValue() !== undefined && this.getField('procedimiento').getValue() !== null) {
            let datos = {
                datos:{
                    produccionformulaciones_id: this.getField('produccionformulaciones_id').getValue(),// body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                    etapa_id: this.getField('etapa_id_select').getValue(),
                    procedimiento: this.getField('procedimiento').getValue(),
                    produccionformulasversiones_id: this.getField('produccionformulasversiones_id').getValue()
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'modificarprocedimiento', operacion_tipo: 'modificar' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: datos,
                success: this.successGuardarProcedimiento,
                error: this.error_,
                general: this.generalFormatPmv
            });
            //console.log('body a enviar',body);
            /*this.generalFormat.nombre_accion = 'servicio-formulaciones_componentes_modificar_orden'; // servicio_cambiar_orden_formalasproductosnombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
            this.service.send(
                {
                    endpoint: this.constant.formConfiguration(),
                    method: 'PUT',
                    body: body,
                    success: this.successGuardarProcedimiento,
                    error: this.error_,
                    general: this.generalFormat
                });*/
        }

    }

    successGuardarProcedimiento(data) {
        if (data.estado_p === 200) {
            //console.log('entro a successGuardar');
            this.getField('modalProcedimiento').handleClose();
            this.consultarEspecificaciones();
        }
    }

    cambiarOrden(pos, opcion) {
        let data = {};
        if (opcion === 1) {

            data = {
                id_item_1: this.gridOptions.api.getRowNode(pos - 1).data.id,//parseInt(this.gridOptions.api.getRowNode(pos-1).data.id),
                id_item_2: this.gridOptions.api.getRowNode(pos).data.id,//parseInt(this.gridOptions.api.getRowNode(pos).data.id),

            }
        } else {
            data = {
                id_item_1: this.gridOptions.api.getRowNode(pos).data.id,//parseInt(this.gridOptions.api.getRowNode(pos).data.id),
                id_item_2: this.gridOptions.api.getRowNode(pos + 1).data.id,//parseInt(this.gridOptions.api.getRowNode(pos+1).data.id),

            }
        }
        let datos = {
            datos: data
        };

        this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'modificarorden', operacion_tipo: 'modificar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'PUT',
            body: datos,
            success: this.successChangeOrden,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_formulas_productos_componentes_cambiar_orden'; // servicio_cambiar_orden_formalasproductosnombre_accion : es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'PUT',
                body: body,
                success: this.successChangeOrden,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successChangeOrden(data) {
        if (data.estado_p === 200) {
            this.consultarEspecificaciones();
        }
    }

    deleteEspecification(id) {
        this.id_delete = id;
        this.getField('confirmModalCustom').setTitleAndContent('Eliminar', 'Desea realizar esta operación?');
        this.getField('confirmModalCustom').setClickDialog(this.confirmDeleteCustom);
        this.getField('confirmModalCustom').toggle(true);

    }

    confirmDeleteCustom() {
        this.getField('confirmModalCustom').toggle(false);
        let datos = {
            datos:{
                id: this.id_delete,    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'eliminar', operacion_tipo: 'eliminar' };
        this.service.send({
            endpoint: this.constant.formConfiguration(),
            method: 'DELETE',
            body: datos,
            success: this.successDelete,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = 'servicio_formulas_productos_componentes_eliminar'; // nombre_accion :servicio_eliminar_formulas_productos, es el nombre que tenga el servicio en la tabla servicios_formulario
        this.service.send(
            {
                endpoint: this.constant.formConfiguration(),
                method: 'DELETE',
                body: body,
                success: this.successDelete,
                error: this.error_,
                general: this.generalFormat
            });*/
    }

    successDelete(model) {
        if (model.estado_p === 200) {      //model.estado_p === undefined 
            this.getField('fieldAlert').toggle(true, "Acción Exitosa", "success");
            this.consultarEspecificaciones();
        }
    }
    grabarDatos() {
        if (this.getField('articulo_id').valid() &
            this.getField('codigo_articulo_modal').valid() &
            this.getField('nombre_articulo_mod').valid() &
            this.getField('etapa_id_select').valid() &
            this.getField('articulo_componente_id').valid() &
            this.getField('unidad_id').valid() &
            this.getField('cantidad_mod').valid() &
            this.getField('orden_mod').valid()
        ) {

            let datos = {
                datos:{
                    articulo_id: this.getField('articulo_id').getValue(),
                    etapa_id: parseInt(this.getField('etapa_id_select').getValue()),
                    articulo_componente_id: this.getField('articulo_componente_id').getValue(),
                    unidad_id: this.getField('unidad_id').getValue(),
                    cantidad: this.getField('cantidad_mod').getValue(),
                    orden: this.getField('orden_mod').getValue(),    // body : es un objeto que contiene los parámetros que se necesitan para realizar la peticion
                    produccionformulaciones_id: this.getField('produccionformulaciones_id').getValue()
                }
            }

            this.generalFormatPmv = { tipo_servicio: 'prod-formulasprodcomponentes', operacion: 'crear', operacion_tipo: 'crear' };
            this.service.send({
                endpoint: this.constant.formConfiguration(),
                method: 'POST',
                body: datos,
                success: this.successPostSustituto,
                error: this.error_,
                general: this.generalFormatPmv
            });
        }
    }

    successPostSustituto(data) {
        if (data.estado_p === 200) {
            this.getField('modalFormulas').handleClose();
            this.getField('fieldAlert').toggle(true, "Acción Exitosa", "success");
            this.getField('cantidad_mod').setValue('');
            this.getField('orden_mod').setValue('');
            this.getField('codigo_articulo_modal').setValue('');
            this.getField('unidad_id').setValue(' ');
            this.getField('etapa_id_select').setValue(' ');
            this.consultarEspecificaciones();
        }
    }

    limpiarCamposModal() {
        this.getField('etapa_id_select').setError(false, '');
        this.getField('codigo_articulo_modal').setError(false, '');
        this.getField('nombre_articulo_mod').setError(false, '');
        this.getField('nombre_unidad_mod').setError(false, '');
        this.getField('cantidad_mod').setError(false, '');
        this.getField('orden_mod').setError(false, '');
    }

}

FormJaivana.addController("prod-formulasprodcomponentes", CustomFormulasProductos);

export default CustomFormulasProductos;